import React from 'react'
import * as TwoStepPaymentForm from '../../../../common/components/entities/TwoStepPaymentForm'
import useManagement, {
  selectors as managementSelectors,
} from '../../../hooks/useManagement'
import useRazorpayPaymentHandler from '../../../hooks/payment/useRazorpayPaymentHandler'
import FieldErrors from '../../FieldErrors'
import { TwoStepPaymentButtonProps } from './TwoStepPaymentButtonProps'

function TwoStepRazorpayPaymentButton({
  entity,
  styles,
  mobileStyles,
}: TwoStepPaymentButtonProps) {
  const { isLoading, isRazorpayReady, isRazorpayFetching, handleSubmit, errors } =
    useRazorpayPaymentHandler(entity)

  const isPreview = useManagement(managementSelectors.isPreviewMode)

  return (
    <React.Fragment>
      <TwoStepPaymentForm.Button
        onClick={handleSubmit}
        styles={styles}
        mobileStyles={mobileStyles}
        text={entity.options.buttonText}
        subText={entity.options.buttonSubText}
        disabled={isLoading || isPreview || !isRazorpayReady || isRazorpayFetching}
      />
      <FieldErrors errors={errors} />
    </React.Fragment>
  )
}

export default TwoStepRazorpayPaymentButton
